import {
  createContextMenuInput,
  type MouseInputAdapter,
  type SelectionUiInteraction,
} from '@databases/selections';

import {
  SelectionFeatureKeys,
  type SelectionInputFeature,
} from '../../features/types.ts';

import { createTableMouseInputAdapter } from './create-table-mouse-input-adapter.ts';

export interface ContextMenuInputFeatureDeps {
  /**
   * Same contract as `FeatureDeps.onSelectionUiInteraction` in mode config; wired
   * by app bootstrap to the enriching sink. Forwarded to `createContextMenuInput`
   * so the input can emit a `contextMenu` interaction with a start time captured
   * at the very top of the `contextmenu` handler.
   */
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

export function createContextMenuInputFeature(
  deps: ContextMenuInputFeatureDeps = {},
  adapter: MouseInputAdapter = createTableMouseInputAdapter(),
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.CONTEXT_MENU_INPUT,
    type: 'input',
    // Always active — context menu input captures right-click events
    // to trigger cell selection before the context menu effect shows.
    factory: (machine) =>
      createContextMenuInput(machine, adapter.hitTest, {
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
